module.exports = __webpack_public_path__ + "static/media/sardines-soy-sauce-lid.a48bfb07.png";